module.exports = __webpack_public_path__ + "static/media/phone.be8a68c7.svg";